import axios from "axios";
import OperationTypes from "../types";
import { ServerSideTypes } from "../types/OperationCommonTypes";

const MasterdataSupplierService = {
  get: {
    allLocations: (tenant: string, pageNumber: number, pageSize: number) => {
      return axios.get<ServerSideTypes.IResult<OperationTypes.Domain>>("masterdatasupplier/location/locationsByFilters", {
        params: {
          tenant,
          pageNumber,
          pageSize,
          currentStatus: "CREATED",
        },
      }).then((response) => {
        return response.data.content;
      });
    }
  }
}

export default MasterdataSupplierService;